export function createAsyncHelper(name, task, { onComplete } = {}) {
  if (!name.startsWith("async")) {
    throw new Error(`name(${name}) must starts with 'async'`);
  }
  const action = createAsyncAction(name, task, { onComplete });
  const state = createAsyncState(name);
  const reducer = createAsyncReducer(name);
  return {
    action,
    state,
    reducer,
  };
}

function createAsyncAction(name, task, { onComplete }) {
  return (param) => (dispatch, getState, extraArgument) => {
    dispatch({ type: getActionType(name, "START") });
    return Promise.resolve()
      .then(() => {
        return task(param, extraArgument, dispatch, getState);
      })
      .then((data) => {
        return !onComplete
          ? data
          : Promise.resolve(onComplete(data, param, extraArgument, dispatch, getState)).then(
              (newData) => (newData !== undefined ? newData : data)
            );
      })
      .then((data) => {
        dispatch({ type: getActionType(name, "COMPLETE"), payload: { param, value: data } });
        return data;
      });
  };
}

const initialState = {
  status: "INITIAL",
  param: undefined,
  value: undefined,
  isReady: false,
};

function createAsyncState(name) {
  return {
    [name]: {
      ...initialState,
    },
  };
}

function createAsyncReducer(name) {
  return (state, action) => {
    switch (action.type) {
      case getActionType(name, "START"):
        return {
          ...state,
          [name]: {
            status: "LOADING",
            param: undefined,
            value: undefined,
            isReady: false,
          },
        };
      case getActionType(name, "COMPLETE"):
        return {
          ...state,
          [name]: {
            status: "COMPLETE",
            param: action.payload.param,
            value: action.payload.value,
            isReady: true,
          },
        };
      default:
        return state;
    }
  };
}

function getActionType(name, type) {
  return `${name}:${type}:g2v9t5kwwmn`;
}
